import {graphql} from 'react-relay'

export const query = graphql`
  query PipelinesSidebarContentQuery {
    pipelinesRest {
      ...PipelinesSidebarFragment
    }
  }
`
